<template>
    <div class="presshead">
        <a href="/" class="logo pc">
            <img src="/images/logo_b.png" class="bg" alt="logo" />
        </a>
        <img src="/images/flight/prev.png" class="prev btn wap" alt="" />
        <div class="pressbox">
            <div class="box btnnav" :class="step > idx ? 'on' : ''" v-for="(item, idx) in steplist"
                @click="toPage(idx, item.path)" :key="idx">
                <span class="num">{{ idx + 1 }}</span>
                <span class="txt">
                    {{ item.title }}
                </span>
            </div>
        </div>
        <img src="/images/flight/next.png" class="next btn wap" alt="" />
        <div class="user-menu-container pc" @click.stop>
            <div class="flex">
                <div class="borderbox profilebox" @click.stop="toggleUserNav">
                    <!-- ponytail: dataUrl() hosts /uploads/* photos on VITE_DATA_URL
                         (test-data.triptogo.com) and leaves local /images/* defaults same-origin. -->
                    <img :src="dataUrl(user.avatar)" class="head" alt="" v-if="user.customerId > 0 && user.avatar != ''" />
                    <i class="icon_user" v-else></i>
                    <span v-if="user.customerId > 0 && user.customerName != ''">
                        {{ user.customerName }}

                        <span style="padding-left:0.2rem;font-weight:normal;" v-if="user.customerGroupId=='3'">
                            | Agent ID: {{user.accountId}} </span>
                        </span>
                    <span v-else @click.stop="openLogin">Login</span>
                </div>
            </div>
            <div class="right navright" v-show="isshownav">
                <div class="block usermenu">
                    <div class="usernav">
                        <UserMenu @setLogout="setLogout" />
                    </div>
                </div>
            </div>
        </div>
  
        <div v-if="(Authorization === 1 && userStore.showLoginDlg == 'login') ">
            <Login @changePage="changePage" @setLogin="initCustomer" @close="close('')" :hide-close="0"></Login>
        </div>
        <div v-if="userStore.showLoginDlg == 'register'">
            <Register @changePage="changePage" @close="close('')"></Register>
        </div>
        <div v-if="page == 'recoverpass'">
            <Recoverpass @changePage="changePage"></Recoverpass>
        </div>
    </div>
</template>
<script>
import Login from "@/components/login.vue";
import Register from "@/components/register.vue";
import Recoverpass from "@/components/recoverpass.vue";
import UserMenu from '@/components/usermenu.vue'
import { useOrderStore } from "@/stores/OrderStore";
import Request from '@/services/Request.ts';
import { notEmpty } from "@/utils/tool.js";
import { useUserStore } from "@/stores/UserStore";
import { dataUrl } from "@/utils/AssetUtils";
import { localDriver } from '@/utils/localDriver'

export default {
    components: {
        Login: Login,
        Register: Register,
        Recoverpass: Recoverpass,
        UserMenu: UserMenu,
    },
    emits: ['refreshStep', 'customerRefresh'],
    props: ['step', 'steplist', 'Authorization'],
    setup() {
        const userStore = useUserStore()
        const user = userStore.user
        const orderStore = useOrderStore()
        return { userStore, user ,orderStore}
    },
    data() {
        return {
            ismobile: false,
            isFilters: true,
            ischeck1: false,
            ischeck2: false,
            ischeck3: false,
            ischeck4: false,
            ischeck5: false,
            waitForClose: false,
            Baggage: ['1Bag'],
            Preferred: ['Basiceconomy'],
            Stops: ['Nonstop'],
            Preferred: ['Lufthansaairline'],
            Sort: ['Price(lowest)'],
            peoplelist: [],
            showselTravBox: false,
            showaddTravBox: false,
            dataForm: {
                phonenum: '+86',
                amount: 'full'
            },
            showHotelBox: false,
            people: [],
            customerInfo: {
                customer_id: 0,
                customer_name: '',
                avater: '',
            },
            page: 'login',
            isshownav: false,
            initstatus: 0,
        };
    },
    created() {
        this.customerLoginInit();
    },
    watch: {

    },
    async mounted() {
        this.ismobile = (document.documentElement.clientWidth < 750);
        await this.redirectHome();
        document.addEventListener('click', this.closeUserNav);
        this.userStore.checkState()
            .then(() => {
                if (this.user.isLogin) {
                    this.waitForClose = false
                }
                else {
                    this.waitForClose = true
                }
            })
    },
    beforeUnmount() {
        document.removeEventListener('click', this.closeUserNav);
    },
    methods: {
        dataUrl:dataUrl,
        async redirectHome(){
            let ctk = new URLSearchParams(window.location.search).get('tk') 
            let od = await localDriver.getItem('order_data_'+ctk)
            if(!notEmpty(od)){
              window.location = '/';            
            }
        },
        close(pageName) {
             if (this.page == 'flight') {
                 this.page = "";
             }
            this.userStore.closeLoginRequest()
        },
        async customerLoginInit() {
            const cachedInfo = await localDriver.getItem('customerInfo') || {};
            new Request().webGet(
                {},
                async (res) => {
                    const responseInfo = res?.data || {};
                    const responseCustomerId = parseInt(responseInfo?.customer_id ?? 0, 10) || 0;
                    const cachedCustomerId = parseInt(cachedInfo?.customer_id ?? 0, 10) || 0;
                    if (res.success) {
                        const keepCache = cachedCustomerId > 0 && cachedCustomerId === responseCustomerId;
                        const mergedInfo = keepCache ? { ...cachedInfo, ...responseInfo } : { ...responseInfo };
                        await localDriver.setItem('customer_id', mergedInfo.customer_id ?? 0)
                        await localDriver.setItem('customerInfo', mergedInfo)
                    } else {
                        await localDriver.setItem('customer_id', 0);
                        await localDriver.setItem('customerInfo', {
                            customer_id: 0,
                            customer_name: '',
                            email: '',
                            avater: '',
                            has_company: 0,
                            member_type: 0,
                            memberType: 0,
                            mmshipHistory: [],
                            membership: null,
                        });
                    }
                    await this.userStore.checkState().catch(() => { });
                    this.initstatus = 1;
                    this.initCustomer();
                },
                'account/login/getAvater',
                (err) => {},
                3000,
                3
            );
        },
        toPage(s, nav) {
            if (this.step > s) {
                this.$emit('refreshStep', { step: parseInt(s) + 1 });
                this.$router.push('/' + nav+'?tk='+this.orderStore.token);
            }
        },
        changePage(p) {
            if ('' != p || this.page == 'flight') {
                this.page = p;
            }
        },
        async initCustomer() {
            let cInfo = await localDriver.getItem('customerInfo')
            if (notEmpty(cInfo)) {
                const customerId = parseInt(cInfo?.customer_id ?? 0, 10) || 0;
                const rawMemberType = cInfo?.member_type
                    ?? cInfo?.memberType
                    ?? cInfo?.mmshipHistory?.[0]?.mmshiptypeid
                    ?? cInfo?.mmshipHistory?.[0]?.description
                    ?? cInfo?.mmshipHistory?.[0]?.name
                    ?? cInfo?.membership?.name
                    ?? cInfo?.membership?.title;
                const storeMemberType = parseInt(this.user?.memberType ?? 0) || 0;
                const parsedMemberType = (() => {
                    const text = String(rawMemberType ?? '').trim().toLowerCase();
                    if (text.includes('inside') || text.includes('insider')) return 1;
                    if (text.includes('voyager')) return 2;
                    if (text.includes('adventurer')) return 3;
                    if (text.includes('elite')) return 4;
                    return parseInt(text, 10) || 0;
                })();
                const mergedMemberType = parsedMemberType || storeMemberType;
                this.customerInfo = {
                    ...cInfo,
                    customer_id: customerId,
                    customer_name: cInfo?.customer_name ?? '',
                    email: cInfo?.email ?? '',
                    avater: cInfo?.avater ?? '',
                    has_company: cInfo?.has_company ?? 0,
                    member_type: mergedMemberType,
                    memberType: mergedMemberType,
                    mmshipHistory: cInfo?.mmshipHistory ?? this.user?.mmshipHistory ?? [],
                };
            }
            else {
                this.customerInfo = {
                    customer_id: 0,
                    customer_name: '',
                    email: '',
                    avater: '',
                    has_company:0,
                    member_type: 0,
                    memberType: 0,
                    mmshipHistory: [],
                    membership: null,
                };
            }
            await localDriver.setItem('customerInfo', this.customerInfo)
            this.$emit('customerRefresh');
        },
        setLogout() {
            this.isshownav = false;
            this.initCustomer();
        },
        openLogin() {
            this.isshownav = false;
            this.userStore.showLoginDlg = 'login';
        },
        toggleUserNav() {
            if (this.user.customerId > 0 || this.customerInfo.customer_id > 0) {
                this.isshownav = !this.isshownav;
                return;
            }
            this.openLogin();
        },
        closeUserNav() {
            this.isshownav = false;
        },
    }
}
</script>

<style>
.el-select__wrapper {
    padding: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
    height: 100%;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.is-selected:after {
    display: none;
}

.el-select__wrapper.is-hovering,
.el-select__wrapper.is-focused,
.el-select__wrapper:hover,
.el-select__wrapper:focus-visible {
    border: 0;
    background: transparent;
    outline: none;
    box-shadow: none !important;
}
</style>
<!-- 公共区域 -->
<style scoped>
.page {
    background: #FAFAFA;
}

.btnnav:hover {
    cursor: pointer;
}

.presshead {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    background: #fff;
    color: #333333;
    height: 7rem;
    transition: all 0.3s ease 0s;
    padding: 0 3rem;
}

.presshead .logo {
    width: 15rem;
}

.presshead .pressbox,
.presshead .pressbox .box {
    display: flex;
    justify-content: center;
    align-items: center
}

.presshead .pressbox .box {
    margin: 0 2.4rem;
    color: #333;
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.4rem;
}

.presshead .pressbox .box .num {
    background: #E1E1E1;
    width: 3.2rem;
    height: 3.2rem;
    line-height: 3.2rem;
    border-radius: 50%;
    text-align: center;
    display: block;
}

.presshead .pressbox .box .txt {
    margin-left: 1.6rem;

}

.presshead .pressbox .box.on .num {
    background: #4F6F52;
    color: #fff;
}

.presshead .borderbox {
    margin-left: 1.2rem;
    border: 1px solid #EAEAEA;
    padding: 0 1.2rem;
    height: 3.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.8rem;
    cursor: pointer;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2.0rem;
}

.presshead .borderbox i.icon_user {
    background-image: url(/images/icon_user_b.png);
}

.presshead .borderbox i {
    margin-right: 0.6rem;
    display: block;
    width: 2rem;
    height: 2rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}

/* header usermenu*/
.user-menu-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.user-menu-container .flex {
    display: flex;
}

.navright .pc {
    display: block;
}

.user-menu-container .borderbox {
    margin-left: 1.2rem;
    border: 1px solid #eaeaea;
    padding: 0 1.2rem;
    height: 3.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.8rem;
    cursor: pointer;
}

.user-menu-container .profilebox {
    display: flex;
    align-items: center;
}

.user-menu-container .profilebox img.head {
    width: 2.4rem;
    height: 2.4rem;
    object-fit: cover;
    border-radius: 50%;
}

img.head {
    height: 2.1rem;
    width: 2.1rem;
    border-radius: 50%
}

.user-menu-container .profilebox span {
    margin-left: 0.6rem;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2rem;
}

.navright .navright {
    justify-content: flex-end !important;
    display: none;
}

.navright .usermenu {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 0.5rem;
    z-index: 99999;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

.navright .usernav {
    padding: 5px;
    height: auto;
    width: 190px;
    background: #fff;
    border-radius: 10px;
    color: #333;
    font-size:1.7333rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.navright .usernav .r {
    display: flex;
    align-items: center;
}

.navright .usernav .r:hover {
    background: #e5e5e5;
    border-radius: 15px;
}

.navright .usernav img {
    height: 25px;
    width: 25px;
    margin-right: 5px;
}

.navright .userline {
    border-top: 1px solid #ddd !important;
    padding: 5px 0 !important;
}

/* 移动端  */
@media screen and (max-width:750px) {
    .page {
        padding-top: 5.6rem;
    }

    .presshead {
        top: 5.6rem;
        justify-content: center;
        gap: 0.4rem;
        padding: 0 0.8rem;
        height: 5.6rem;
    }

    .presshead .pressbox {
        flex: 1 1 auto;
        min-width: 0;
        justify-content: space-between;
    }

    .presshead .pressbox .box {
        flex: 0 0 auto;
        margin: 0;
    }

    .presshead .btn {
        flex: 0 0 3rem;
        width: 3rem;
        display: block;
    }

    .presshead .pressbox .box .num {
        width: 2.6rem;
        height: 2.6rem;
        line-height: 2.6rem;
        font-size: 1.2rem;
    }

    .presshead .pressbox .box .txt {
        display: none;
        white-space: nowrap;
        font-size: 1.4rem;
    }

    .presshead .pressbox .box.on:last-child .txt {
        margin-left: 0.8rem;
        display: block;
        font-size: 1.1rem;
        line-height: 1.4rem;
    }
}
</style>
